import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import ScrollToTop from '../components/ScrollToTop';
import Modal from '../components/Modal';
import HomeHero from '../components/home/HomeHero';
import HomeStats from '../components/home/HomeStats';
import HomeMosaic from '../components/home/HomeMosaic';
import InstructorsCarousel from '../components/home/InstructorsCarousel';
import FeaturedCourses from '../components/home/FeaturedCourses';
import LearningPathRecommender from '../components/home/LearningPathRecommender';
import StudentWorkSlider from '../components/home/StudentWorkSlider';
import Testimonials from '../components/Testimonials';

export default function HomePage({ theme, toggleTheme, defaultModal }) {
  const [modalContent, setModalContent] = useState(defaultModal || null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (defaultModal) {
      setModalContent(defaultModal);
    } else if (location.pathname === '/') {
      setModalContent(null);
    }
  }, [defaultModal, location.pathname]);

  const openModal = (type) => {
    if (type === 'terms') navigate('/TermsConditions');
    else if (type === 'privacy') navigate('/privacypolicy');
    else setModalContent(type);
  };

  const closeModal = () => {
    if (location.pathname === '/TermsConditions' || location.pathname === '/privacypolicy') {
      navigate('/');
    } else {
      setModalContent(null);
    }
  };

  return (
    <div className="relative w-full">
      <div className="sticky top-0 z-50">
        <Navbar theme={theme} toggleTheme={toggleTheme} />
      </div>
      <main className="flex-grow">
        <HomeHero />
        <FeaturedCourses />
        <LearningPathRecommender />
        <Testimonials />
        <StudentWorkSlider />
        <HomeMosaic />
        <InstructorsCarousel />
        <HomeStats />
      </main>
      <FloatingWhatsApp />
      <ScrollToTop />
      <Modal content={modalContent} onClose={closeModal} />
      <Footer openModal={openModal} />
    </div>
  );
}
